import { useSelector } from "react-redux";
import Button from "../../../../../../../../common/Buttons/Button";
import Typography from "../../../../../../../../common/Typography";

const AlreadySubscribedMembStep = ({
  setState,
  handleClose,
  setCurrMemb,
  membershipId,
}) => {
  const shortLinkData = useSelector((state) => state?.shortLink);

  const subsMembs = shortLinkData?.subscribedMemberships;

  const handleViewMembership = () => {
    const memb = subsMembs?.find((mem) => mem?.membership_id === membershipId);
    setCurrMemb(memb ?? {});
    handleClose();
    setState({
      otp: "",
      customer_mobile: "",
      step: "enter-phone",
      paymentFailedReason: "",
    });
  };

  return (
    <div className="already-subscribed-div">
      <div className="check-circle-parent">
        <img
          width={56}
          alt="check"
          height={56}
          src="/assets/icons/check-circle.svg"
        />
      </div>
      <Typography tag="h2" weight="medium" size="display-xl">
        You’re already subscribed to this membership
      </Typography>
      <Button
        fullWidth={true}
        text="View your membership"
        handleClick={handleViewMembership}
      />
    </div>
  );
};

export default AlreadySubscribedMembStep;
